export const PARTNER_TUTORIAL_STYLE = {
  options: {
    zIndex: 10000,
  },
};
export const PARTNER_TUTORIAL = [
  {
    target: 'body',
    title: 'Welcome!',
    content: "* Introducing Charts! * To see how your new dashboard works, let's Get Started below.",
    locale: {
      next: 'Get Started',
      skip: 'Skip',
    },
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    placement: 'center',
  },
  {
    target: '.switchLayoutIcons',
    content:
      'Now you can toggle from Card Layout & Graph Layout to see more advanced metrics. Hover on Charts to get more granular.',
    placement: 'bottom-end',
    styles: PARTNER_TUTORIAL_STYLE,
    eBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Graph Layout',
  },
  {
    target: '.dropzone.top .cardHeaderColor',
    content: 'You can even click the metric box to see a mini-chart.',
    placement: 'bottom-start',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Mini Chart',
  },
  {
    target: '.dropzone.top .graph_card_extras',
    content: 'You can also Refresh & Manange individual metrics.',
    placement: 'bottom',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Manage Metric',
  },
  {
    target: '.time_span_option',
    content: 'Change the Time Range using this dropdown.',
    placement: 'bottom-start',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Time Span',
  },
  {
    target: '.dropzone.top .grid-item',
    content: 'You can also drag & drop any cards to match your preferences.',
    placement: 'bottom-start',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Drag & Drop',
  },
  {
    target: '.locationTools',
    content: 'You can still filter by Providers and Office Locations.',
    placement: 'bottom-end',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Provider & Location Filters',
  },
  {
    target: '.extraTools',
    content: 'Full-Screen and Auto-Refresh are also available. Plus the ability to add Custom Cards is on the way!',
    placement: 'bottom-end',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Extras',
  },
  {
    target: '.burger',
    content: 'You can click here to collapse the Menu Bar.',
    placement: 'bottom-start',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Menu',
  },
  {
    target: '.classic_link',
    content: 'The Classic Dashboard is still available here.',
    placement: 'right',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Classic',
  },
  {
    target: '.logout_link',
    content: 'Signing out has been moved down here.',
    placement: 'top-start',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    title: 'Log Out',
  },
  {
    target: 'body',
    content: 'This is just the beginning, new ways to expand your reporting are coming soon!',
    placement: 'center',
    styles: PARTNER_TUTORIAL_STYLE,
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    showSkipButton: false,
    title: "But wait, there's more!",
    locale: {
      last: 'Finish Tutorial',
    },
  },
];
